import { render } from "./ClientShow.vue?vue&type=template&id=dde098fc"
import script from "./ClientShow.vue?vue&type=script&lang=js"
export * from "./ClientShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__